import { css } from '@emotion/css';
import { SpacingToken } from '@livechat/design-system-react-components';

export const switcherWrapper = css`
  margin-bottom: var(${SpacingToken.Spacing3});
`;
